var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.hasActions
    ? _c("balloon-actions", {
        attrs: {
          actions: _vm.actions,
          mode: _vm.balloonActionsMode,
          "balloon-style-props": _vm.balloonStyleProps,
          theme: "secondaryAlt",
        },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }